import { authAtom} from '_state';
import { useRecoilState } from 'recoil';
import { useFetchWrapper } from '_helpers';
import { usePushWrapper } from './push-wrapper';
import { useAlertActions ,useProfileAction} from '_actions';
import { alertBachAtom } from '_state';
export { useAuthWrapper };

function useAuthWrapper(param) {
      // console.log("Login in wrapper called");
      const [auth, setAuth] = useRecoilState(authAtom);
      // const [user, setUser] = useRecoilState(userAtom);
      const [alert, setAlert] = useRecoilState(alertBachAtom)
      const fetchWrapper = useFetchWrapper();
      const pushWrapper = usePushWrapper();
      const alertActions = useAlertActions();
      const profileAction = useProfileAction();

      async function login(param){
          const response = await fetchWrapper.post("/api/auth/login", "application/x-www-form-urlencoded", param);
          let rawjson = await response.json()
            if (rawjson.status === "Logged In Success"){
              setLoginToken(rawjson.message.token);
              await loadUser();
            } else {
              setAlert({message: "Thất bại", description: "Sai tên đăng nhập hoặc mật khẩu"});
            }
            return rawjson
        }

        async function logout(){
            // Drop this device's push subscription first so the next person to use
            // the browser doesn't inherit the previous user's notifications.
            try { await pushWrapper.disablePush(); } catch(e) {}
            // Token is now httpOnly — JS cannot read it. Always call the server to
            // clear it; if there's no session the server returns an error we swallow.
            try { await fetchWrapper.post('/api/auth/logout', null, null); } catch(e) {}
            setLoginToken("");
            setAlert({message: null, description: null});
            localStorage.clear();
        }

        function setLoginToken(token){
            // The real auth cookie is set server-side as httpOnly.
            // We store a non-secret "logged-in" marker in Recoil so the UI knows
            // the user is authenticated without touching document.cookie.
            setAuth(token || "");
        }

        async function loadUser(){
          const response = await fetchWrapper.get("/api/profile/me", null, null);
          if (!response?.ok) throw new Error('Unable to load user');
          let rawjson = await response.json()
          if (rawjson.status !== 'Success' || !rawjson.message) {
            throw new Error('Unable to load user');
          }
          rawjson = rawjson.message

          // Fetch authoritative capabilities from the backend so the client
          // never has to duplicate role-permission logic.
          let capabilities = {};
          try {
            const capRes = await fetchWrapper.get("/api/auth/me", null, null);
            const capJson = await capRes.json();
            if (capJson.status === 'Success') capabilities = capJson.message.capabilities;
          } catch (_) {}

          var userProfile = {
            name: rawjson.name,
            role: rawjson.role,
            date_of_birth: rawjson.date_of_birth,
            email: rawjson.email,
            student_id: rawjson.student_id,
            capabilities,
          }
          profileAction.getMyProfile();
          localStorage.setItem('userData', JSON.stringify(userProfile));
          setAuth('authenticated');

          // If this device already has notifications on, re-sync the subscription
          // to the server (keeps the endpoint→user mapping current). No prompt is
          // shown; skipped entirely when not already subscribed.
          try {
            if ((await pushWrapper.getStatus()) === 'subscribed') {
              await pushWrapper.enablePush();
            }
          } catch (_) { /* best-effort */ }
        }

        async function getUserInfo() {
          let data = JSON.parse(localStorage.getItem("userData"))
          if (data  && data.student_id) {
            return data
          }

          else {
            await loadUser();
          }
          return JSON.parse(localStorage.getItem("userData"))
        }

        async function forgetPassword(params) {
          var urlencoded = new URLSearchParams();
          urlencoded.append("email", params.email);
          let response = {message: ""};
          try {
            response = await fetchWrapper.post("/api/auth/forget_password", "application/x-www-form-urlencoded", urlencoded);
            response = await response.json();
            // console.log(response)
            if (response.status == "Success") {
              setAlert({message: "Thành công", description: "Kiểm tra email của bạn để nhận hướng dẫn đặt lại mật khẩu"})
            } else throw Error("Forget Password fail")
          } catch (e) {
            setAlert({message: "Thất bại", description: response.message})
          }
        }

        async function resetPassword(params) {
          var urlencoded = new URLSearchParams();
          urlencoded.append("token", params.token);
          urlencoded.append("password", params.password);
          let response = {message: ""};
          try {
            response = await fetchWrapper.post("/api/auth/reset_password", "application/x-www-form-urlencoded", urlencoded);
            response = await response.json();
            if (response.status == "Success") {
              setAlert({message: "Thành công", description: response.message})
            } else throw Error("Reset Password fail")
          } catch (e) {
            setAlert({message: "Thất bại", description: response.message})
          }
          return response;
        }

        return {
          login : login,
          logout : logout,
          tokenValue : auth,
          getUserInfo : getUserInfo,
          forgetPassword: forgetPassword,
          resetPassword: resetPassword,
          loadUser
       };
      }

